interface LogoProps {
  /** `sm` (24px símbolo/19px wordmark) para a sidebar; `md` (32px/24px) para telas isoladas (login/onboarding). */
  size?: 'sm' | 'md';
  className?: string;
}

const SIZES = {
  sm: { icon: 24, text: 'text-lg' },
  md: { icon: 32, text: 'text-2xl' },
} as const;

/**
 * Símbolo canônico "nó de junção" (docs/brand — três entradas, uma saída, nó
 * sólido em `--color-primary`) + wordmark `trivio` + `fy` (o sufixo herda a
 * cor primária, mesma convenção do brand deck). Único lugar do dashboard que
 * desenha o SVG diretamente (em vez de vir do pacote `tervior-shared-ui-react`,
 * que não exporta o símbolo do produto Trivio — só o Header/Footer
 * institucionais da Tervior).
 */
export function Logo({ size = 'sm', className = '' }: LogoProps) {
  const { icon, text } = SIZES[size];
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg
        viewBox="0 0 32 32"
        width={icon}
        height={icon}
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        strokeLinecap="square"
        aria-hidden="true"
        className="shrink-0 text-foreground"
      >
        <path d="M2 7h9l5 9" />
        <path d="M2 16h14" />
        <path d="M2 25h9l5-9" />
        <path d="M16 16h14" />
        <rect x="13" y="13" width="6" height="6" fill="currentColor" stroke="none" className="text-primary" />
      </svg>
      <span className={`${text} font-medium leading-none tracking-tight text-foreground`}>
        trivio<span className="text-primary">fy</span>
      </span>
    </div>
  );
}
